<!--  -->
<template>
  <div class="recordPrize">
    <div v-if="list.length">
      <div class="recordPrize-item" v-for="(item, idx) in list" :key="idx">
      <div class="record-item-left">
        <h3>{{ item.title }}</h3>
        <span>{{ item.createTime }}</span>
      </div>
      <div class="record-item-right">
        <p  @click="checkAdr(item)">{{ item.isCompleted === 0 ? '填写地址' : '查看地址' }}</p>
      </div>
    </div>
    </div>
    <EmptyData v-if="!list.length" />
  </div>
</template>

<script>
import EmptyData from './emptyData.vue';
import { reqPrizeRecord } from '@/api/collectCard/index';
export default {
  components: {
    EmptyData
  },
  data() {
    return {
      list: [],
      loading: true,
      finished: true,
    };
  },
  props: {
    cardActiveId: {
      type: String,
      default: 0,
    },
  },
  computed: {},
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    async getData() {
      this.$toast.loading({
        duration: 0,
        message: '',
        forbidClick: true,
      });
      const res = await reqPrizeRecord({ id: this.cardActiveId });
      if (res?.code === 0) {
        this.list = res?.data;
      }
      this.$toast.clear();
    },
    checkAdr(item){
      this.$router.push({
        path: '/cardAdress',
        query: {
          cardActiveId: this.cardActiveId,
          isCompleted: item.isCompleted,
          recordId:item.id
        },
      });
    }
  },
};
</script>
<style lang='scss' scoped>
.recordPrize {
  width: 678px;
  margin: 0 auto;
  padding-bottom: 50px;
  .recordPrize-item {
    display: flex;
    justify-content: space-between;
    align-content: center;
    background: #ffffff;
    border-radius: 14px;
    margin-bottom: 20px;
    padding: 30px;

    .record-item-left {
      h3 {
        font-weight: 500;
        font-size: 29px;
        color: #333333;
      }
      span {
        font-weight: 400;
        font-size: 22px;
        color: #999999;
      }
    }

    .record-item-right {
      display: flex;
      align-items: center;

      p {
        width: 116px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: #ff7f41;
        border-radius: 22px;
        font-weight: 400;
        font-size: 22px;
        color: #ffffff;
      }
    }
  }
}
</style>